import React, { useState } from "react";
import Loader from "../../Common/Loader";
import { noDataFound } from "../../../CommonMethhods/CommonMethods";
import { Modal } from "react-bootstrap";
import SmallLoader from "../../Common/smallLoader";
import { useClientStockContext } from "./context/ClientStockContext";
import LoaderForSearch from "../../Common/LoaderForSearch";

const AnalyticsStockModal = () => {
  const {
    modalOpen,
    setModalOpen,
    fetchClientStockData,
    clientStockData,
    totalRecords,
    loading,
    smallLoader,
    scrollLoader,
    setScrollLoader,
  } = useClientStockContext();

  const [page, setPage] = useState(1);

  const handleTableScroll = (e) => {
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoader) {
      const nextPage = page + 1;
      const totalLoadedRecords = page * 10;

      if (
        totalRecords > totalLoadedRecords &&
        totalRecords !== clientStockData?.length
      ) {
        setPage(nextPage);
        setScrollLoader(true);
        fetchClientStockData("grid", nextPage);
      } else {
        setScrollLoader(false);
      }
    }
  };

  return (
    <Modal
      show={modalOpen}
      onHide={() => {
        setModalOpen(false);
        setPage(1);
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="mb-4 modal-header">
        <Modal.Title id="contained-modal-title-vcenter modal-title">
          <p style={{ marginTop: "8px" }}>Stock Details</p>
        </Modal.Title>

        <div className="d-flex">
          <button
            className="generate-btn text-green mr-3"
            value="excel"
            onClick={() => fetchClientStockData("excel", -1)}
          >
            {smallLoader ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                {"Excel"}
              </>
            )}
          </button>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setModalOpen(false);
              setPage(1);
            }}
            style={{ backgroundColor: "transparent" }}
          >
            <span className="icon-close"></span>
          </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive  model-top-active-table">
          {loading ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : clientStockData && clientStockData.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th className="text-center">Market Cap Category</th>
                  <th className="text-center">Scrip Name</th>
                  <th className="text-center">ISIN Code</th>
                  <th className="text-center">Sector</th>
                  <th className="text-center">Quantity</th>
                  <th className="text-center">Buy Price</th>
                  <th className="text-center">Current Price</th>
                </tr>
              </thead>

              <tbody onScroll={(e) => handleTableScroll(e)}>
                {clientStockData.map((item) => (
                  <tr key={item.partyCode}>
                    <td className="text-center">{item?.mCap || "-"}</td>
                    <td className="text-center">{item?.nseSymbol || "-"}</td>
                    <td className="text-center">{item?.isin || "-"}</td>
                    <td className="text-center">{item?.sector || "-"}</td>
                    <td className="text-center">{item?.netQty || "-"}</td>
                    <td className="text-center">{item?.avgPrice || "-"}</td>
                    <td className="text-center">{item?.clRate || "-"}</td>
                  </tr>
                ))}
                {scrollLoader && !loading && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            </table>
          ) : (
            noDataFound()
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AnalyticsStockModal;
